import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../../lib/eventUtils";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/api/auth/session`,
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true }
        );
        window.history.replaceState(null, "", window.location.pathname);
        const target = location.pathname.startsWith("/admin") ? location.pathname : "/admin/events";
        navigate(target, { replace: true, state: { user: data } });
      } catch (err) {
        window.history.replaceState(null, "", window.location.pathname);
        const target = location.pathname.startsWith("/admin") ? location.pathname : "/admin/events";
        navigate(target, {
          replace: true,
          state: { authError: err.response?.data?.detail || "Sign-in failed. Please try again." },
        });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#070707] flex items-center justify-center" data-testid="auth-callback-screen">
      <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-zinc-400 animate-pulse">Signing you in…</p>
    </div>
  );
};
